import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    marginTop: 10,
    marginBottom: 10,
    borderBottomColor: '#d1d5db', // Tailwind's gray-300
    borderBottomWidth: 1, // Matches your original quotation divider
  },
});

const InvoiceLine = () => <View style={styles.titleContainer} />;

export default InvoiceLine;
